<!-- version 1.0.0 -->
<!-- 2017-9-17 -->
<template>
  <div class="mc-upload-wrap video-upload-warp">
    <div class="isout-switch-wrap hf" v-if="workMode === 'upload-outer'">
      <div class="label ftp">Is OutLink</div>
      <div class="ftp">
        <el-switch v-model="isOuterUrl" on-text="" off-text="" @change="changeOuter"></el-switch>
      </div>
    </div>
    <template v-if="(workMode === 'upload-outer' || workMode === 'outer') && isOuterUrl === true">
      <!-- 外链地址 -->
      <el-input size="small" v-model="videoUrl" @change="outerIptChange"></el-input>
    </template>
    <template v-if="(workMode === 'upload-outer' || workMode === 'upload') && isOuterUrl === false">
      <!-- 本地上传 -->
      <div class="upload-field" :class="{'has-upload':videoUrl}" :style="{ width: width + 'px' }" v-fileupload="videoUrl" v-on:upload-change="videoUploadSuccess">
        <div class="tip">UPLOAD</div>
        <div class="pic-wrap">
          <video :src="videoUrl"></video>
        </div>
        <div class="upload-cover">Change</div>
      </div>
    </template>
  </div>
</template>

<script>
// import $ from 'jquery'
// import tools from '@/components/common/tools'

export default {
  name: 'videoUpload',
  props: {
    // 工作模式
    // upload
    // outer
    // upload-outer
    workMode: {
      type: String,
      default: 'upload-outer'
    },
    isOuter: {
      type: Boolean,
      default: true
    },
    width: {
      type: Number,
      default: 400
    },
    url: {
      type: String,
      default: ''
    }
  },
  created() {
  },
  data() {
    return {
      isOuterUrl: this.isOuter,
      videoUrl: this.url
    }
  },
  watch: {
    // 工作模式变化
    workMode(newVal) {
      if (this.workMode === 'upload-outer' || this.workMode === 'outer') {
        this.isOuter = true
      } else if (this.workMode === 'upload') {
        this.isOuter = false
      }
    },
    // 是否外链变化
    isOuter(newVal) {
      this.isOuterUrl = newVal
    },
    // url变化
    url(newVal) {
      this.videoUrl = newVal
    }
  },
  methods: {
    // 改变是否外链
    changeOuter() {
      this.$emit('update:isOuter', this.isOuterUrl)
      this.$emit('update:url', '')
    },
    // 外链输入框值变化
    outerIptChange() {
      this.$emit('update:url', this.videoUrl)
    },
    // 本地视频上传成功
    videoUploadSuccess(val) {
      this.$emit('update:url', val)
    }
  }
}
</script>

<style lang="scss">
@import "~@/style/lib-config";
.isout-switch-wrap {
  line-height: 36px;
  .label {
    margin-right: 5px;
  }
}

.video-upload-warp {
  width: 400px;
}
</style>



// WEBPACK FOOTER //
// video-upload.vue?41e4cb73